// extracted by mini-css-extract-plugin
module.exports = {"maskedNumber":"src-components-PaymentCardNumber-PaymentCardNumberComponent-index-module__maskedNumber--1vvPv"};